






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BaseReportSection extends Vue {
  @Prop({ default: false }) readonly bordered!: boolean;
}
